import {layoutData} from 'sopix/app-frame/layoutData'
import {action} from 'mobx'

export const setLayoutTitle = action((title) => {
    layoutData.title = title
    document.title = `${title} - ${layoutData.appName}`
})